import React, { FunctionComponent } from 'react';
import { Alert } from '@nbc-design/alert';
import { Button } from '@nbc-design/button';
import { Card } from '@nbc-design/card';
import { Text } from '@nbc-design/text';
import TextList from '@nbc-design/text-list';
import { InjectedIntl } from 'react-intl';
import { getTextFactory } from 'utils/TextUtils';
import { AttentionOutlineThinColor } from '@nbc-design/icons/lib/web/AttentionOutlineThinColor';
import { redirectToUnifiedLogin } from 'services/ssoRedirectService';
import { sendClickAnalyticsEvent } from 'services/analytics';
import { sendStepLoadedAnalyticsEvent } from '../utils';

export type EmailAlreadyExistsProps = {
  intl: InjectedIntl;
  email: string;
};

const EmailAlreadyExists: FunctionComponent<EmailAlreadyExistsProps> = ({ intl, email }) => {
  React.useEffect(() => {
    sendStepLoadedAnalyticsEvent('EXISTS_EMAIL');
  }, []);

  const getText = getTextFactory(intl, 'createCredentials');
  const getAccessibilityText = getTextFactory(intl, 'accessibility');

  const handleGoToLogin = () => {
    sendClickAnalyticsEvent('already existing customer', 'Go to Login');
    redirectToUnifiedLogin(intl.locale);
  };

  return (
    <Card border="shadow" className="spc-creationProfil__card mb-4">
      <div className="spc-creationProfil__popupCardBody">
        <AttentionOutlineThinColor title="attention-outline-thin-color" size={{ width: 64, height: 64 }} />
        <div className="text-wrapper">
          <Text className="mb-4 popup-title">{getText('emailAlreadyExistsTitle')}</Text>
          <Text className="email-explanation">
            {getText('emailAlreadyExistsPrefix')} {email} {getText('emailAlreadyExistsAssociatedWith')}
          </Text>
          <TextList>
            <TextList.Item className="list-explanations">{getText('emailAlreadyExistsReasonBrokerage')}</TextList.Item>
            <TextList.Item className="list-explanations">
              {getText('emailAlreadyExistsReasonOtherService')}
            </TextList.Item>
          </TextList>
          <Text size="xSmall" className="extra-explanation">
            {getText('emailAlreadyExistsConsolidatedAccess')}
          </Text>
          <Alert
            appearance="information"
            title={
              <>
                <b>{getText('emailAlreadyExistsForgotPassword')}</b> {getText('emailAlreadyExistsContactInfo')}
              </>
            }
            ariaLabelIcon={getAccessibilityText('icon.information')}
            size="small"
            className="info-block"
          />
        </div>
        <div className="button-wrapper">
          <Button appearance="primary" onClick={handleGoToLogin}>
            {getText('emailAlreadyExistsSignIn')}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default EmailAlreadyExists;
